/** @format */

export default {
  root: {
    backgroundColor: '#fff',
    borderBottom: '1px solid #d8d8d8',
  },
};
